import config from "./../../common/config";

const data = [
  {
    id: 1,
    name: "home",
    transKey: "menuHome",
    titleTransKey: "homeTabTitle",
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    platform: config.enumPlatformForMenu.both,
    link: config.enumStaticUrls.home,
    linkMenu: config.enumStaticUrls.home,
    isAuthorize: 0,
    isEndOfTour: 0,
    isActive: (match, location) => {
      if (match) {
        return true;
      }
    },
    // isActive: (match, location) => {
    //   if (location.pathname === config.BASE_DOMAIN.slice(0, -1)) {
    //     return true;
    //   }
    // },
    iconClassName: "pd-Home",
  },
  {
    id: 2,
    name: "myMatches",
    transKey: "menuMatches",
    titleTransKey: "myMatchesTabTitle",
    isRemove: false,
    platform: config.enumPlatformForMenu.both,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.matches,
    linkMenu: config.enumStaticUrls.matches,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.matches}`) > -1) {
        return true;
      }
    },
    isAuthorize: 0,
    isEndOfTour: 0,
    iconClassName: "pd-Matches",
  },
  {
    id: 3,
    name: "leaderboard",
    transKey: "menuLeaderboard",
    titleTransKey: "leaderboardTabTitle",
    isRemove: false,
    platform: config.enumPlatformForMenu.both,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.leaderboard,
    linkMenu: config.enumStaticUrls.leaderboard,
    isActive: (match, location) => {
      if (
        location.pathname.indexOf(`/${config.enumStaticUrls.leaderboard}`) > -1
      ) {
        return true;
      }
    },
    isAuthorize: 1,
    isEndOfTour: 0,
    iconClassName: "pd-Leaderboard",
  },
  {
    id: 4,
    name: "rules",
    transKey: "menuRules",
    titleTransKey: "rulesTabTitle",
    platform: config.enumPlatformForMenu.desktop,
    isRemove: false,
    isHideMenu: false,
    isMaster: false,
    link: config.enumStaticUrls.rules,
    linkMenu: config.enumStaticUrls.rules,
    isActive: (match, location) => {
      if (location.pathname.indexOf(`/${config.enumStaticUrls.rules}`) > -1) {
        return true;
      }
    },
    isAuthorize: 0,
    isEndOfTour: 0,
    iconClassName: "pd-rules",
  },
  // {
  //   id: 5,
  //   name: "terms",
  //   transKey: "menuTerms",
  //   titleTransKey: "termsTabTitle",
  //   platform: config.enumPlatformForMenu.desktop,
  //   isRemove: false,
  //   isHideMenu: false,
  //   isMaster: false,
  //   link: config.enumStaticUrls.terms,
  //   linkMenu: config.enumStaticUrls.terms,
  //   isActive: (match, location) => {
  //     if (location.pathname.indexOf(`/${config.enumStaticUrls.terms}`) > -1) {
  //       return true;
  //     }
  //   },
  //   isAuthorize: 0,
  //   isEndOfTour: 0,
  //   iconClassName: "pd-tnc",
  // },
];
export default data;
